// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checklist-select-report-dialog-content {
  padding: 5px;
}
.checklist-select-report-dialog-content .report-name > a {
  display: block;
  padding: 5px 10px;
}`, "",{"version":3,"sources":["webpack://./Source/app/checklist-report/view/checklist-report-select-report-dialog/checklist-report-select-report-dialog.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;AAEQ;EACI,cAAA;EACA,iBAAA;AAAZ","sourcesContent":[".checklist-select-report-dialog-content {\r\n    padding: 5px;\r\n\r\n    .report-name {\r\n        > a {\r\n            display: block;\r\n            padding: 5px 10px;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
